goog.provide("shadow.js.shim.module$src$svg$artwork$legacy_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$legacy_svg");
shadow.js.shim.module$src$svg$artwork$legacy_svg = shadow.js.nativeProvides["src/svg/artwork/legacy.svg"] = shadow$bridge("src/svg/artwork/legacy.svg");
module$shadow_js_shim_module$src$svg$artwork$legacy_svg.default = shadow.js.shim.module$src$svg$artwork$legacy_svg;
